(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-empty"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mini-bag-empty')) {
    customElements.define('mini-bag-empty', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelector('[data-continue-shopping]').addEventListener('click', () => {
          this.closest('mini-cart')?.close();
        });
        this.querySelector('details').addEventListener('toggle', (event) => {
          if (event.target.open && !this.loading && !this.loaded) this.loadRecent();
        });
      }

      async loadRecent() {
        const status = this.querySelector('[data-recent-status]');
        const list = this.querySelector('[data-recent-products]');
        const history = window.theme?.recentlyViewed;
        const productApi = window.theme?.product;
        if (!history || !productApi) return;
        const handles = history.get({ limit: 20 });
        if (!handles.length) return;
        this.loading = true;
        status.textContent = status.dataset.loadingText;
        list.setAttribute('aria-busy', 'true');
        try {
          const results = await Promise.allSettled(handles.map(handle => productApi.loadProduct(handle)));
          const products = results.filter(result => result.status === 'fulfilled' && result.value?.handle).map(result => result.value);
          const fragment = document.createDocumentFragment();
          products.forEach(product => {
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = (window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(product.handle);
            const source = product.featured_image?.src || product.featured_image || product.images?.[0]?.src || product.images?.[0];
            if (typeof source === 'string') {
              const image = document.createElement('img');
              const imageUrl = new URL(source, window.location.origin);
              if (imageUrl.protocol === 'https:') {
                imageUrl.searchParams.set('width', '180');
                image.src = imageUrl.href;
                image.alt = '';
                image.width = 72;
                image.height = 72;
                image.loading = 'lazy';
                link.appendChild(image);
              }
            }
            const info = document.createElement('span');
            const title = document.createElement('span');
            title.textContent = product.title;
            info.appendChild(title);
            if (Number.isFinite(Number(product.price)) && window.theme?.money) {
              const price = document.createElement('span');
              price.className = 'mini-bag-empty__price';
              price.textContent = window.theme.money.format(Number(product.price));
              info.appendChild(price);
            }
            link.appendChild(info);
            item.appendChild(link);
            fragment.appendChild(item);
          });
          list.replaceChildren(fragment);
          list.hidden = products.length === 0;
          status.hidden = products.length > 0;
          this.loaded = products.length > 0;
        } finally {
          this.loading = false;
          list.removeAttribute('aria-busy');
          status.textContent = status.dataset.emptyText;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-add-to-cart-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    const bar = document.getElementById('product-add-to-cart-bar');
    const source = document.querySelector('[data-add-to-cart-main]');
    const productForm = document.querySelector('product-form');
    const form = productForm && productForm.querySelector('form');
    const submitBtn = form && form.querySelector('[type="submit"][name="add"]');
    if (!bar || !source || !form || !submitBtn) return;

    const barSubmit = bar.querySelector('[data-bar-submit]');
    const barLabel = bar.querySelector('[data-bar-label]');
    const barPrice = bar.querySelector('[data-bar-price]');
    const barBtnPrice = bar.querySelector('[data-bar-btn-price]');
    const variantSelector = productForm.querySelector('variant-selector');
    let buttonLabel = bar.dataset.buttonLabel;
    let buttonState = 'available';
    let selectedPrice = '';
    let requestVersion = 0;
    let updateTimer;
    const priceCache = new Map();

    function setBarPrices(price) {
      selectedPrice = price;
      barPrice.textContent = price;
      barPrice.hidden = !price;
      barBtnPrice.textContent = price ? ' | ' + price : '';
      barSubmit.setAttribute('aria-label', [barLabel.textContent, price].filter(Boolean).join(' '));
    }

    function formatPrice(priceInCents) {
      if (window.theme && window.theme.money && window.theme.money.format) {
        return window.theme.money.format(priceInCents, true);
      }
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: bar.dataset.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(priceInCents / 100);
    }

    async function updatePrice(version) {
      try {
        const data = new FormData(form);
        const variantId = data.get('id') || bar.dataset.initialVariant;
        const quantity = Number(data.get('qty') || data.get('quantity') || 1);
        const properties = {};
        data.forEach(function (value, name) {
          const match = name.match(/^properties\[([^\]]+)\]$/);
          if (match && value !== '') properties[match[1]] = value;
        });
        const signature = JSON.stringify([bar.dataset.currency, variantId, quantity, properties]);
        let total = priceCache.get(signature);
        if (total === undefined) {
          if (properties._loose_stone) {
            const variant = variantSelector && typeof variantSelector.getVariant === 'function'
              ? variantSelector.getVariant() : null;
            total = Number(variant ? variant.price : bar.dataset.initialAmount) * quantity;
          } else {
            const cart = window.theme && window.theme.cart;
            if (!cart || typeof cart._getComponentsProperty !== 'function') return;
            const components = JSON.parse(await cart._getComponentsProperty(variantId, properties));
            if (!components.length) return;
            total = Math.round(components.reduce(function (sum, component) {
              return sum + Number(component.price) * Number(component.qty || 1);
            }, 0) * 100) * quantity;
          }
          if (!Number.isFinite(total) || total < 0) return;
          priceCache.set(signature, total);
        }
        if (version === requestVersion) setBarPrices(formatPrice(total));
      } catch (error) {
        if (version === requestVersion) setBarPrices('');
      }
    }

    function schedulePrice() {
      requestVersion += 1;
      const version = requestVersion;
      clearTimeout(updateTimer);
      setBarPrices('');
      updateTimer = setTimeout(function () { updatePrice(version); }, 100);
    }

    function setBarButtonState(state) {
      buttonState = state;
      const loading = state === 'loading';
      const soldOut = state === 'sold-out';
      barSubmit.disabled = loading || soldOut;
      barLabel.textContent = loading
        ? (form.dataset.editLineKey ? bar.dataset.savingLabel : bar.dataset.addingLabel)
        : (soldOut ? bar.dataset.soldOutLabel : buttonLabel);
      barBtnPrice.hidden = loading || soldOut;
      barSubmit.setAttribute('aria-label', [barLabel.textContent, loading || soldOut ? '' : selectedPrice].filter(Boolean).join(' '));
    }

    function syncAvailability() {
      if (buttonState === 'loading') return;
      const variant = variantSelector && typeof variantSelector.getVariant === 'function'
        ? variantSelector.getVariant() : null;
      setBarButtonState(variant && !variant.available ? 'sold-out' : 'available');
    }

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        const visible = entry.boundingClientRect.bottom <= 0;
        ['opacity-0', 'pointer-events-none', 'translate-y-full'].forEach(function (name) {
          bar.classList.toggle(name, !visible);
        });
        bar.setAttribute('aria-hidden', String(!visible));
      });
    }, { threshold: 0, rootMargin: '0px' });
    observer.observe(source);

    form.addEventListener('change', schedulePrice);
    form.addEventListener('input', function (event) {
      if (event.target.name === 'qty' || event.target.name === 'quantity') schedulePrice();
    });
    productForm.addEventListener('variant-change', function () {
      syncAvailability();
      schedulePrice();
    });
    productForm.addEventListener('cart-edit:loaded', function () {
      buttonLabel = bar.dataset.saveLabel;
      syncAvailability();
      schedulePrice();
    });
    if (variantSelector) variantSelector.addEventListener('ready', function () {
      syncAvailability();
      schedulePrice();
    });

    barSubmit.addEventListener('click', function () {
      if (barSubmit.disabled) return;
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      setBarButtonState('loading');
      submitBtn.click();
    });
    productForm.addEventListener('product-form:addtocart-complete', function () {
      buttonLabel = form.dataset.editLineKey ? bar.dataset.saveLabel : bar.dataset.buttonLabel;
      buttonState = 'available';
      syncAvailability();
      schedulePrice();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', schedulePrice, { once: true });
    } else {
      schedulePrice();
    }
    window.addEventListener('pageshow', function () {
      syncAvailability();
      schedulePrice();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-properties"] && !Shopify.designMode) return;
  try {
    (function () {
    function initializeAddonPrices() {
      document.querySelectorAll('[data-addon-prices]').forEach(function (container) {
        if (container.dataset.addonInitialized) return;
        const form = container.closest('form');
        const productForm = container.closest('product-form');
        if (!form || !productForm) return;
        container.dataset.addonInitialized = 'true';
        const entries = [];
        const rates = new Map();
        let requestVersion = 0;
        let timer;

        function addEntry(element, price) {
          const amount = Number(price);
          if (!element || !Number.isFinite(amount) || amount <= 0) return;
          const original = element.textContent;
          if (!original.includes('$')) return;
          entries.push({ element: element, price: amount, original: original });
        }

        ['_size', '_length', '_number_of_initials'].forEach(function (name) {
          const select = container.querySelector('select[name="properties[' + name + ']"]');
          if (!select) return;
          Array.from(select.options).forEach(function (option) {
            addEntry(option, option.value.split(':')[1]);
          });
        });
        container.querySelectorAll('input[name="properties[_warranty]"]').forEach(function (input) {
          const label = container.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          addEntry(label && label.lastElementChild, input.value.split(':')[1]);
        });
        const appraisal = container.querySelector('input[name="properties[_appraisal]"]');
        if (appraisal) {
          const label = container.querySelector('label[for="' + CSS.escape(appraisal.id) + '"]');
          const text = label && Array.from(label.querySelectorAll('span')).find(function (span) {
            return span.textContent.includes('$');
          });
          addEntry(text, appraisal.value.split(':')[1]);
        }

        function showBaseCurrency() {
          if (container.dataset.currency === 'USD') return;
          entries.forEach(function (entry) {
            entry.element.textContent = entry.original.replace(/\$/g, 'US$');
          });
        }

        async function updatePrices(version) {
          const cart = window.theme && window.theme.cart;
          if (!cart || typeof cart._getMarketRate !== 'function' || typeof cart._formatAddonPrice !== 'function') return;
          try {
            const data = new FormData(form);
            const ids = [data.get('properties[_setting_id]'), data.get('id') || container.dataset.initialVariant];
            const key = JSON.stringify(ids);
            if (!rates.has(key)) {
              rates.set(key, cart._getMarketRate(ids).catch(function (error) {
                rates.delete(key);
                throw error;
              }));
            }
            const rate = await rates.get(key);
            if (version !== requestVersion) return;
            if (!Number.isFinite(rate) || rate <= 0) throw new Error('Invalid add-on exchange rate');
            entries.forEach(function (entry) {
              const price = cart._formatAddonPrice(entry.price, rate);
              entry.element.textContent = entry.original.replace(/\$[\d,.]+/, function () { return price; });
            });
            container.dataset.addonCurrency = container.dataset.currency;
          } catch (error) {
            if (version === requestVersion) showBaseCurrency();
          }
        }

        function schedule() {
          requestVersion += 1;
          const version = requestVersion;
          clearTimeout(timer);
          timer = setTimeout(function () { updatePrices(version); }, 75);
        }

        showBaseCurrency();
        form.addEventListener('change', schedule);
        productForm.addEventListener('variant-change', schedule);
        productForm.addEventListener('cart-edit:loaded', schedule);
        const variants = productForm.querySelector('variant-selector');
        if (variants) variants.addEventListener('ready', schedule);
        window.addEventListener('pageshow', schedule);
        schedule();
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAddonPrices, { once: true });
    } else {
      initializeAddonPrices();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
